export const TICKETING_SET_DATA = 'TICKETING_SET_DATA';
export const TICKETING_SET_LAST_PAGE = 'TICKETING_SET_LAST_PAGE';
export const TICKETING_SET_TOTAL_ROWS = 'TICKETING_SET_TOTAL_ROWS';
export const TICKETING_SET_CURRENT_ROW = 'TICKETING_SET_CURRENT_ROW';
export const TICKETING_SET_RELOAD_DATA = 'TICKETING_SET_RELOAD_DATA';
export const TICKETING_SET_GRID_LOADING = 'TICKETING_SET_GRID_LOADING';
export const TICKETING_SET_TICKET_LOADING = 'TICKETING_SET_TICKET_LOADING';
export const TICKETING_SET_PUBLISH_COMMENT_LOADING =
  'TICKETING_SET_PUBLISH_COMMENT_LOADING';
export const TICKETING_SET_TICKET_DATA = 'TICKETING_SET_TICKET_DATA';
export const TICKETING_PUSH_TICKET_MESSAGE = 'TICKETING_PUSH_TICKET_MESSAGE';
export const TICKETING_SET_TICKET_STATUSES = 'TICKETING_SET_TICKET_STATUSES';
export const TICKETING_SET_TICKET_CATEGORIES =
  'TICKETING_SET_TICKET_CATEGORIES';
export const TICKETING_SET_LOADING_TICKET_CATEGORIES =
  'TICKETING_SET_LOADING_TICKET_CATEGORIES';
export const TICKETING_UPDATE_TICKET_DATA = 'TICKETING_UPDATE_TICKET_DATA';
export const TICKETING_TOGGLE_CREATE_TICKET_MODAL =
  'TICKETING_TOGGLE_CREATE_TICKET_MODAL';
export const TICKETING_ADD_TEMPRARY_TICKET_ID =
  'TICKETING_ADD_TEMPRARY_TICKET_ID';
export const TICKETING_REMOVE_TEMPRARY_TICKET_ID =
  'TICKETING_REMOVE_TEMPRARY_TICKET_ID';
export const TICKETING_SET_CHECK_NEW_TICKETS =
  'TICKETING_SET_CHECK_NEW_TICKETS';
